import React from 'react';
import HeroImg from '../assets/bg-header.jpg';

const videos = [
  {
    src: "https://www.youtube.com/embed/1VpVc9vqkAk",
    title: "Learning The “Circular Swing Pattern” for the Spin Serve",
  },
  {
    src: "https://www.youtube.com/embed/ZSzWKlj34M0",
    title: "The Flat Serve Unlocked",
  },
  {
    src: "https://www.youtube.com/embed/-YbhgJh1zGE",
    title: "Serve Tips with Alain 🎾: The Ball Toss",
  },
  {
    src: "https://www.youtube.com/embed/Pc3aoTEWV8w",
    title: "Serve Tips with Alain: The Spin Serve",
  },
  {
    src: "https://www.youtube.com/embed/dj-8y8WJd_s",
    title: "First Serve aka The Flat Serve",
  },
  {
    src: "https://www.youtube.com/embed/yjZwXWEXGws",
    title: "Second Serve Demonstration",
  },
];

export default function Videos() {
  return (
    <main className="font-sans antialiased bg-gray-50 min-h-screen">
      {/* Hero Section */}
      <section className="relative h-[50vh] flex items-center justify-center bg-black overflow-hidden">
        <img src={HeroImg} alt="Tennis Videos" className="absolute inset-0 w-full h-full object-cover opacity-60" />
        <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-transparent to-black/70" />
        <div className="relative z-10 text-center text-white max-w-4xl mx-auto px-6 animate-fade-in">
          <h1 className="text-5xl md:text-6xl font-extrabold mb-4 tracking-tight">Coaching <span className="text-primary italic">Vault</span></h1>
          <div className="w-16 h-1.5 bg-primary mx-auto rounded-full" />
        </div>
      </section>

      <section className="py-24 max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-navy">Bite-Sized Lessons</h2>
          <p className="mt-4 text-gray-600">Master the basics and refine your strategy with these video highlights.</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10">
          {videos.map((video, idx) => (
            <div key={idx} className="group bg-white rounded-3xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 border border-gray-100 pb-6">
              <div className="aspect-video w-full bg-black">
                <iframe
                  width="100%"
                  height="100%"
                  src={video.src}
                  title={video.title}
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  allowFullScreen
                  className="w-full h-full"
                />
              </div>
              <div className="p-6">
                <h3 className="text-lg font-bold text-navy leading-tight line-clamp-2 group-hover:text-primary transition-colors">
                  {video.title}
                </h3>
              </div>
            </div>
          ))}
        </div>
      </section>

      <footer className="py-12 bg-navy text-white text-center">
        <p className="opacity-60 text-sm">© 2025 Alain Brouillaud | Spin Doctor Tennis</p>
      </footer>
    </main>
  );
}
